import { createReducer } from "typesafe-actions";

import { EntityTypeSupportingCustomFields } from "@mapmycustomers/shared/types/entity";

import {
  Actions,
  createCustomField,
  deleteCustomField,
  fetchAllCustomFields,
  fetchCustomFields,
  updateCustomField,
  updateCustomFieldBulk,
} from "./actions";
import CustomFieldsSate from "./CustomFieldsState";
import { stateFieldBaseName } from "./util";

const initialState: CustomFieldsSate = {
  activityCustomFields: [],
  activityCustomFieldsError: undefined,
  activityCustomFieldsLoading: false,
  companyCustomFields: [],
  companyCustomFieldsError: undefined,
  companyCustomFieldsLoading: false,
  customFieldCreating: false,
  customFieldDeleting: false,
  customFieldUpdating: false,
  dealCustomFields: [],
  dealCustomFieldsError: undefined,
  dealCustomFieldsLoading: false,
  peopleCustomFields: [],
  peopleCustomFieldsError: undefined,
  peopleCustomFieldsLoading: false,
};

const customFields = createReducer<CustomFieldsSate, Actions>(initialState)
  .handleAction(fetchCustomFields.request, (state, { payload }) => ({
    ...state,
    [`${stateFieldBaseName[payload.entityType]}`]: [],
    [`${stateFieldBaseName[payload.entityType]}Error`]: undefined,
    [`${stateFieldBaseName[payload.entityType]}Loading`]: true,
  }))
  .handleAction(fetchCustomFields.success, (state, { payload: { entityType, fields } }) => ({
    ...state,
    [`${stateFieldBaseName[entityType]}`]: fields,
    [`${stateFieldBaseName[entityType]}Loading`]: false,
  }))
  .handleAction(fetchCustomFields.failure, (state, { payload: { entityType, error } }) => ({
    ...state,
    [`${stateFieldBaseName[entityType]}Error`]: error,
    [`${stateFieldBaseName[entityType]}Loading`]: false,
  }))
  .handleAction(fetchAllCustomFields.success, (state, { payload }) => {
    return (Object.keys(payload) as EntityTypeSupportingCustomFields[]).reduce(
      (result, entityType) => {
        return { ...result, [`${stateFieldBaseName[entityType]}`]: payload[entityType] };
      },
      state
    );
  })
  .handleAction(updateCustomFieldBulk.request, (state, { payload: { entityType, fields } }) => ({
    ...state,
    [`${stateFieldBaseName[entityType]}`]: fields,
  }))
  .handleAction(deleteCustomField.request, (state) => ({
    ...state,
    customFieldDeleting: true,
  }))
  .handleAction(deleteCustomField.success, (state, { payload }) => ({
    ...state,
    [`${stateFieldBaseName[payload.entityType]}`]: state[
      `${stateFieldBaseName[payload.entityType]}`
    ].filter(({ id }) => id !== payload.id),
    customFieldDeleting: false,
  }))
  .handleAction(deleteCustomField.failure, (state) => ({
    ...state,
    customFieldDeleting: false,
  }))
  .handleAction(createCustomField.request, (state) => ({
    ...state,
    customFieldCreating: true,
  }))
  .handleAction(createCustomField.success, (state) => ({
    ...state,
    customFieldCreating: false,
  }))
  .handleAction(createCustomField.failure, (state) => ({
    ...state,
    customFieldCreating: false,
  }))
  .handleAction(updateCustomField.request, (state) => ({
    ...state,
    customFieldUpdating: true,
  }))
  .handleAction(updateCustomField.success, (state) => ({
    ...state,
    customFieldUpdating: false,
  }))
  .handleAction(updateCustomField.failure, (state) => ({
    ...state,
    customFieldUpdating: false,
  }));

export * from "./selectors";
export type CustomFieldsActions = Actions;
export default customFields;
